import { createModel, RematchDispatch } from '@rematch/core';
import * as tourAdminApi from '../../../services/admin/tour.service';
import TourType from '../../../types/admin/tour.type';
import { PaginationResponseType } from '../../../types/CommonTypes';
import { RootModel } from '../../models';
import baseEntity from '../base.entity';

export const storeName = 'tourAdminEntity';

export const tourAdminEntity: any = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof tourAdminEntity>) => ({
    async load(params): Promise<PaginationResponseType<TourType>> {
      try {
        const res = await tourAdminApi.getAdminTours(params);
        const { content } = res.data;
        if (content && content.length) {
          this.saves(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async loadById(id, state): Promise<TourType> {
      try {
        const res = await tourAdminApi.getAdminTour(id);
        const tour = res.data;
        if (tour) {
          this.saves([tour]);
        }
        return tour;
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default tourAdminEntity;
